import React from "react";

const ImageIcon = props => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={20}
    viewBox="0 0 24 20"
    {...props}
  >
    <defs>
      <rect id="a" width={180} height={41} y={10} rx={4} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-11 -21)">
        <use fill="#FFF" xlinkHref="#a" />
        <rect width={179} height={40} x={0.5} y={10.5} stroke="#F2F2F2" rx={4} />
      </g>
      <path fill="#FFF" stroke="#F2F2F2" d="M1.314-17.686h16v16h-16z" />
      <path fill="#FFF" d="M-3-10h30V6H-3z" />
      <g fill="currentColor" fillRule="nonzero">
        <path d="M21.5 2h-3.789L16.029.163A.496.496 0 0 0 15.661 0H8.339a.5.5 0 0 0-.369.163L6.289 2H2.5A2.503 2.503 0 0 0 0 4.5v13C0 18.878 1.122 20 2.5 20h19c1.378 0 2.5-1.122 2.5-2.5v-13C24 3.122 22.878 2 21.5 2zM12 4c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7z" />
        <path d="M12 17c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6z" />
      </g>
    </g>
  </svg>
);

export default ImageIcon;
